<template>
    <div>
        <el-form-item>
            <tms-text-editor height="400"
                :content="config[field.key]"
                v-on:contentUpdated="updateContent"
            ></tms-text-editor>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

    /**
     * Created by huangdonglin on 2018/1/3.
     */

    import TmsTextEditor from '@/components/TmsTextEditor';

    export default {
        name: 'tms-type-rich-text',
        props: {
            field: {
                type: [Object, Array],
                required: true
            },
            source: {
                type: String,
            }
            // config: {
            //     type: Object,
            //     default() {
            //         return {}
            //     }
            // }
        },
        computed: {
           config() {
                if (this.source === 'tmsPageConfig') {
                    return this.$store.state.tms.pageData
                }
                if (this.source === 'tmsModuleConfig') {
                    return this.$store.state.tms.config;
                }
                return this.$store.state.tms.customConfig;
            }
        },
        data() {
            return {}
        },
        // watch: {
        //     config(val) {
        //         console.log(this.$store.state.tms.customConfig, 1111111);
        //         console.log(val);
        //     }
        // },
        components: {
            TmsTextEditor,
        },

        mounted() {

        },

        methods: {
            updateContent(content) {
                this.$set(this.config,this.field.key,content);
            },
        }
    }

</script>
